import { createContext } from 'react';

function createGlobalTooltipState() {
  return {
    activeRef: null,
    listeners: new Set(),
    subscribe: function subscribe(listener) {
      var _this = this;

      this.listeners.add(listener);
      return function () {
        _this.listeners.delete(listener);
      };
    },
    show: function show(ref) {
      this.activeRef = ref;
      this.listeners.forEach(function (listener) {
        return listener(ref);
      });
    },
    hide: function hide(ref) {
      if (this.activeRef === ref) {
        this.activeRef = null;
        this.listeners.forEach(function (listener) {
          return listener(null);
        });
      }
    }
  };
}

var TooltipContext = /*#__PURE__*/createContext(undefined);
export { TooltipContext as T, createGlobalTooltipState as c };